const seedrandom = require("seedrandom")

const generateSeededRandomPid = (str) => {
  const seeded_rndm_pid = seedrandom(str).quick()
  const seeded_random_page_id = Math.floor(100000 + seeded_rndm_pid * 900000)

  return seeded_random_page_id
}

module.exports = generateSeededRandomPid
